import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface RejectReasonDialogData {
  title?: string;
  description?: string;
}

@Component({
  selector: 'hmt-reject-reason-dialog',
  templateUrl: './reject-reason-dialog.component.html',
  styleUrls: ['./reject-reason-dialog.component.scss'],
  standalone: false,
})
export class RejectReasonDialogComponent {
  form = new FormGroup({
    reason: new FormControl('', [Validators.required]),
  });
  reasonMissingError = false;

  readonly title: string;
  readonly description: string;

  constructor(
    public dialogRef: MatDialogRef<RejectReasonDialogComponent, string>,
    @Inject(MAT_DIALOG_DATA) public data: RejectReasonDialogData
  ) {
    this.title = data?.title || 'Reject Invoice';
    this.description = data?.description
      || 'Please provide a reason for rejecting this invoice. This reason will be visible to the Logistics Service Provider and stored in the audit trail.';

    this.form.get('reason').valueChanges.subscribe((value: string) => {
      if (value && value.trim().length > 0) {
        this.reasonMissingError = false;
      }
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  submit(): void {
    const reasonControl = this.form.get('reason');
    const value = (reasonControl.value || '').trim();
    if (!value) {
      this.reasonMissingError = true;
      reasonControl.markAsTouched();
      return;
    }
    this.dialogRef.close(value);
  }
}
